import { Component, OnInit, inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from './layout/service/app.layout.service';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UsuarioService } from './services/auth/usuario.service';
import { CustomMessageService } from './services/utils/message.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule]
})
export class AppComponent implements OnInit {
  private readonly primengConfig = inject(PrimeNGConfig);
  private readonly layoutService = inject(LayoutService);

  color = localStorage.getItem('colorScheme') || 'light';

  theme = localStorage.getItem('theme') || 'saga-purple';
  private router = inject(Router);
  private usuarioService = inject(UsuarioService);
  private messageService = inject(CustomMessageService);

  hiddenTime: number | null = null;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event instanceof NavigationEnd) {
          if (event.url !== '/auth/login' && event.url !== '/') {
            sessionStorage.setItem('last_url', event.url);
          } else if (event.url === '/') {
            sessionStorage.removeItem('last_url');
          }
        }

        if (event.url.includes('auth')) return;
        let usuario = localStorage.getItem('usuario');
        let token = localStorage.getItem('token');
        if (!token || !usuario) {
          this.messageService.alert('You loose your credentials, please login again', 'Access denied');
          this.usuarioService.logout();
        }
        this.usuarioService.verificarCaducudadToken();
      }
    });

    // esta funcion se ejecuta cuando se cambia de pestaña
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    let diezMinutos = 10 * 60 * 1000; // 10 minutos

    if (document.hidden) {
      this.hiddenTime = Date.now();
    } else {
      if (this.hiddenTime && Date.now() - this.hiddenTime >= diezMinutos) {
        this.usuarioService.verificarCaducudadToken();
      }
      this.hiddenTime = null;
    }
  };

  ngOnInit() {
    this.primengConfig.ripple = true;

    //optional configuration with the default configuration
    this.layoutService.config = {
      ripple: false, //toggles ripple on and off
      inputStyle: 'outlined', //default style for input elements
      menuMode: 'static', //layout mode of the menu, valid values are "static" and "overlay"
      colorScheme: 'light', //color scheme of the template, valid values are "light" and "dark"
      theme: 'saga-purple', //default component theme for PrimeNG
      scale: 14 //size of the body font size to scale the whole application
    };
  }
}
